import React from 'react'
import Truck from '../images/Truck.gif'
import Bin from '../images/Bin.gif'
import Trolley from '../images/Trolley.gif'
import Box from '../images/Box.gif'
import room from '../images/room.gif'
import Location from '../images/Location.gif'
import {Row,Col,Card} from 'react-bootstrap'
import Fade from 'react-reveal/Fade';

const ServicePage = () => {
  
  return (
    <div>
      <div className='ServiceBanner container-fluid'>
        <div className='text-center pt-4'>
         <Fade right><h6 style={{color:'#ffff',fontFamily: 'Lato, sans-serif'}}>OUR SERVICE</h6></Fade> 
          <Fade left><h1 style={{color:'#ffff',fontFamily: 'Lato, sans-serif',fontWeight: '700'}}>Services We Provide</h1></Fade>
        </div>
      <Row className='px-5 pt-5 justify-content-center'>
      <Col md={4}>
      <a href='/local-movers' style={{textDecoration:'none'}}>
         <Card className='zoom' style={{ width: '18rem', margin:'auto', cursor:'pointer', marginBottom:'10px',transition: 'transform 0.3s' }}>
          <Card.Body>
            <Card.Title style={{textAlign:'center'}}>
                <img src={Trolley} alt='locacal Mover' style={{ width: '50%'}}/>
            </Card.Title>
            <h4 className="mb-2 text-center" style={{fontFamily: 'lato, sans-serif',fontWeight: '600'}}>Local Movers</h4>
            <Card.Text className='text-center' style={{fontFamily: 'lato, sans-serif'}}>
            All UK Movers are committed to delivering a hassle-free moving experience for all local moves across the UK. </Card.Text>
            <a href='/local-movers' className='atagServ'><p className='text-center mb-0 hoverRead' style={{fontFamily: 'Lato, sans-serif'}}>Read more</p></a>
          </Card.Body>
        </Card></a> 
      </Col>
      <Col md={4}>
      <a href='/long-distance-movers' style={{textDecoration:'none'}}>
        <Card className='zoom' style={{ width: '18rem', margin:'auto', cursor:'pointer', marginBottom:'10px',transition: 'transform 0.3s' }}>
          <Card.Body>
            <Card.Title style={{textAlign:'center'}}>
                <img src={Truck} alt='locacal Mover' style={{ width: '50%'}}/>
            </Card.Title>
            <h4 className="mb-2 text-center" style={{fontFamily: 'Lato, sans-serif',fontWeight: '600'}}>Long Distance Movers</h4>
            <Card.Text className='text-center' style={{fontFamily: 'Lato, sans-serif'}}>
            Long-distance moves require careful planning and execution. From your first consultation to the final delivery
            </Card.Text>
            <a href='/long-distance-movers' className='atagServ'><p className='text-center mb-0' style={{fontFamily: 'Lato, sans-serif'}}>Read more</p></a>
          </Card.Body>
        </Card></a>
      </Col>
      <Col md={4}>
      <a href='/junk-removal' style={{textDecoration:'none'}}>
      <Card className='zoom' style={{ width: '18rem', margin:'auto', cursor:'pointer', marginBottom:'10px',transition: 'transform 0.3s' }}>
          <Card.Body>
            <Card.Title style={{textAlign:'center'}}>
                <img src={Bin} alt='locacal Mover' style={{ width: '50%'}}/>
            </Card.Title>
            <h4 className="mb-2 text-center" style={{fontFamily: 'Lato, sans-serif',fontWeight: '600'}}>Junk Removal</h4>
            <Card.Text className='text-center' style={{fontFamily: 'Lato, sans-serif'}}>
            At All UK Waste Solutions, we’re committed to helping you keep your spaces clean, clear, and environmentally responsible
             </Card.Text>
            <a href='/junk-removal' className='atagServ'><p className='text-center mb-0' style={{fontFamily: 'Lato, sans-serif'}}>Read more</p></a>
          </Card.Body>
        </Card></a>
      </Col>
      </Row>
      <Row className='px-5 py-5 justify-content-center'>
      <Col md={4}>
      <a href='/packaging-services' style={{textDecoration:'none'}}>
      <Card className='zoom' style={{ width: '18rem', margin:'auto', cursor:'pointer', marginBottom:'10px',transition: 'transform 0.3s' }}>
          <Card.Body>
            <Card.Title style={{textAlign:'center'}}>
                <img src={Box} alt='locacal Mover' style={{ width: '50%'}}/>
            </Card.Title>
            <h4 className="mb-2 text-center" style={{fontFamily: 'lato, sans-serif',fontWeight: '600'}}>Packing Services</h4>
            <Card.Text className='text-center' style={{fontFamily: 'Lato, sans-serif'}}>
            Relocating can be overwhelming, but with All UK Movers’ professional packing services, you can enjoy a stress-free, efficient packing experience.
            </Card.Text>
            <a href='/packaging-services' className='atagServ'><p className='text-center mb-0' style={{fontFamily: 'Lato, sans-serif'}}>Read more</p></a>
          </Card.Body>
        </Card></a> 
      </Col>
      <Col md={4}>
      <a href='/moving-supplier' style={{textDecoration:'none'}}>
      <Card className='zoom' style={{ width: '18rem', margin:'auto', cursor:'pointer', marginBottom:'10px',transition: 'transform 0.3s' }}>
          <Card.Body>
            <Card.Title style={{textAlign:'center'}}>
                <img src={Location} alt='locacal Mover' style={{ width: '50%'}}/>
            </Card.Title>
            <h4 className="mb-2 text-center" style={{fontFamily: 'lato, sans-serif',fontWeight: '600'}}>Moving Supplies</h4>
            <Card.Text className='text-center' style={{fontFamily: 'Lato, sans-serif'}}>
            At All UK Movers, we provide a full range of premium moving supplies to make your relocation smooth, safe, and efficient.
            </Card.Text>
            <a href='/moving-supplier' className='atagServ'><p className='text-center mb-0' style={{fontFamily: 'Lato, sans-serif'}}>Read more</p></a>
          </Card.Body>
        </Card></a>
      </Col>
      <Col md={4}>
      <a href='/storage-services' style={{textDecoration:'none'}}>
      <Card className='zoom' style={{ width: '18rem', margin:'auto', cursor:'pointer', marginBottom:'10px',transition: 'transform 0.3s' }}>
          <Card.Body>
            <Card.Title style={{textAlign:'center'}}>
                <img src={room} alt='locacal Mover' style={{ width: '50%'}}/>
            </Card.Title>
            <h4 className="mb-2 text-center" style={{fontFamily: 'lato, sans-serif',fontWeight: '600'}}>Storage Services</h4>
            <Card.Text className='text-center' style={{fontFamily: 'Lato, sans-serif'}}>
            At All UK Storage Solutions, we understand that finding safe, flexible, and affordable storage options is essential during a move, renovation, or when you need extra space. 
            </Card.Text>
            <a href='/storage-services' className='atagServ'><p className='text-center mb-0' style={{fontFamily: 'Lato, sans-serif'}}>Read more</p></a>
          </Card.Body>
        </Card></a>
      </Col>
      </Row>
      </div>
    </div>
  )
}

export default ServicePage
